import { render, staticRenderFns } from "./OkrCollapse.vue?vue&type=template&id=709d7e59"
import script from "./OkrCollapse.vue?vue&type=script&lang=js"
export * from "./OkrCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports